import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Input, Button, Alert, } from 'reactstrap'
import saveContentEdit from '../../../helpers/content/manageContent/saveContentEdit';

class TextInput extends Component {
  state = {
    content: this.props.content + '' || '',
    error: '',
    saving: false,
  }

  handleChange = ({target}) => this.setState({content: target.value})

  save = () => {
    const { activeItemId, contentType } = this.props
    const { content } = this.state
    this.setState({saving: true})
    saveContentEdit(contentType, activeItemId, content)
      .then(() => this.setState({saving: false, error: ''}))
      .catch(error => this.setState({error}))
  }

  componentDidUpdate = prevProps => {
    const { activeItemId, content } = this.props
    if (prevProps.activeItemId !== activeItemId) {
      this.setState({content: content + '' || ''})
    } 
  }
  
  render() {
    const { 
      content,
      error,
      saving,
    } = this.state
    const {
      contentType,
      loading,
      query,
    } = this.props
    const {
      save,
      handleChange,
    } = this
    const headers = {
      audioLink: 'Audio Link',
      videoLink: 'Video Link',
      imageLink: 'Image Link',
      videoFeedback: 'Video Feedback iFrame',
      videoFeedbackThumbnail: 'Video Feedback Thumbnail Image URL',
    }
    const header = headers[contentType]

    return (
      <Card>
        <CardHeader>
          <i className='icon-note icons font-1xl mt-2'></i>
          {header}
        </CardHeader>
        <CardBody>
          <Input 
            type='text'
            value={content}
            onChange={handleChange}
          />
          <Button onClick={save} disabled={saving}>
            {saving ? 'Saving' : 'Save'}
          </Button>
          {error && <Alert>Error saving.</Alert>}
        </CardBody>
      </Card>
    )
  }
}

export default TextInput


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/TextInput.js